import {IFilteringOptions} from "../detail/actions/fetch_offer_detail_offers_list";
import {ISelectedRegion} from "../list/actions/offer_list_selected_data_actions";
import {ISlugParsed} from "./friendly_offer_list/offer_url_parser";

export const getOfferListNearbyFilters = (params: Partial<ISlugParsed> | null, singleRegion?: ISelectedRegion) => {
    if (params != null) {
        const {type, rooms_0, rooms_1, area_0, area_1} = params;
        const filteringOptions: IFilteringOptions = {
            ...(type ? {type} : {}),
            ...(rooms_0 ? {rooms_0} : {}),
            ...(rooms_1 ? {rooms_1} : {}),
            ...(area_0 ? {area_0} : {}),
            ...(area_1 ? {area_1} : {}),
            ...(singleRegion ? {region: singleRegion.id} : {})
        };
        return filteringOptions;
    }
    return {};
};
